export const transformPickUpTimeDto = _ref => {
  let {
    from,
    to,
    is_available
  } = _ref;
  return {
    from,
    to,
    isAvailable: is_available
  };
};
export const transformPickUpDateDto = _ref2 => {
  let {
    date,
    is_available,
    times
  } = _ref2;
  return {
    date,
    isAvailable: is_available,
    times: times ? times.map(transformPickUpTimeDto) : null
  };
};
export const transformPickUpDatesDto = pickUpDates => pickUpDates.map(transformPickUpDateDto);